module.exports = require("webpack");


//////////////////
// WEBPACK FOOTER
// external "webpack"
// module id = 80
// module chunks = 0